import PropTypes from 'prop-types';

export const FlagPropTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  slug: PropTypes.string,
};

export const FlagsDefaultProps = {
  flags: [],
};

export const FlagsPropTypes = {
  flags: PropTypes.arrayOf(PropTypes.shape({ ...FlagPropTypes })),
};
